import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import type { GetUserInvitationsResponse } from '../../../../typings/api';

function fetchUserInvitations() {
  return get<GetUserInvitationsResponse>('/api/user-invitations');
}

//  Exported because after creating/deleting an invitation, we need to invalidate this query.
export const userInvitationsQueryKey: QueryKey = ['user-invitations'];

/**
 * Get a list of active user invitations.
 */
export default function useUserInvitations() {
  return useQuery<GetUserInvitationsResponse>({
    queryKey: userInvitationsQueryKey,
    queryFn: fetchUserInvitations,
  });
}
